import type { Object3D } from "three"

export default function findFirstThreeObject3D (
  object: Object3D,
  fn: (obj: Object3D) => boolean,
): Object3D | null {
  let obj : Object3D | null = null

  object.traverse((child) => {
    if (!obj && fn(child)) {
      obj = child
    }
  })

  return obj
}
